var map = {
	"./delivery.png": "d977",
	"./delivery_large.png": "e86c",
	"./feedback.png": "55b6",
	"./feedback_large.png": "6e7e",
	"./partner.png": "60e4",
	"./partner_large.png": "71cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc5d";